export default "__VITE_ASSET__CT__tEVl__"